import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Datamanager } from "src/app/model/Datamanager";
import { Page } from "src/app/model/Page";
import { ExportImportService } from "src/app/services/export-import.service";
import { ImportMasterService } from "src/app/services/import-master.service";
@Component({
  selector: "app-secure-import-bulkPol",
  templateUrl: "./import-bulkPol.component.html",
  styleUrls: ["./import-results.component.scss"],
})
export class ImportBulkPolComponent implements OnInit {
  page: Page<Datamanager>;
  lotteries: {[key: number]: string};
  uploadMasterTypes: string[];
  isLoading = false;
  loaded: boolean = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  lotteryList: {[key: number]: string};
  reports: {[key: number]: string};
  selectedFile: File;
  successMessage: string;
  errorMessage: String;
  errorFile: string;
  @ViewChild('localForm') localForm : NgForm;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<Datamanager> = new MatTableDataSource();
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private importMasterService: ImportMasterService
   
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.loaded = true;
    this.form = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      importMasterType: new FormControl("", Validators.required),
      file: new FormControl(null, Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.importMasterService.initImportDocumentForm().subscribe((data) => {
        if(data.status === 'SUCCESS') {
          this.lotteries = data.lotteries;
          this.uploadMasterTypes = data.uploadMasterTypes;
        }
        else {
          this.importMasterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.importMasterService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit() {
    if (this.form.valid) {
      this.successMessage = null;
      this.errorMessage = null;
      this.errorFile = null;
      this.loaded = false;

      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.importMasterService
        .importLetter(
          this.form.value.lotteryKey.key, 
          this.form.value.importMasterType,
          reader.result
        )
        .subscribe((data: any) => {
          this.isSubmitDisabled = false;
          
          if(data.status === 'SUCCESS') {
            this.successMessage = "Successfully imported File";
            this.localForm.resetForm({
              lotteryKey: "",
              importMasterType: "",
              file: null
            });
            this.selectedFile = null;
            this.importMasterService.successToast("Successfully imported File");
            this.loaded = true;
          }
          else {
            this.localForm.resetForm({
              lotteryKey: this.form.value.lotteryKey,
              importMasterType: this.form.value.importMasterType,
              file: null
              
            });
            this.selectedFile = null;
            this.errorMessage = "Failed to import, Please check error file.";
            this.errorFile = data.errorFile;
            this.loaded = true;
          }
        }, error => {
          this.localForm.resetForm({
            lotteryKey: "",
            importMasterType: "",
            file: null
          });
          this.selectedFile = null;
          this.isSubmitDisabled = false;
          console.log(error);
          this.importMasterService.errorToast(error?.error?.message||error?.error?.errorMessage, 5*1000);
          this.loaded = true;
        });
      };      
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  refresh() {
    this.loadData();
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}